import { DataType } from "@cloudpivot/form/typings";
export default {
    $id: "description",
    type: DataType.Object,
    properties: {
        name: {
            type: DataType.String,
            title: "控件名称",
        },
        displayFormula: {
            type: DataType.String,
            title: "显示条件",
        },
    },
};
